import { forwardRef } from 'react';

import { IconProps } from '.';

export const CloseSmallIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M13.51 11.92C13.6505 12.0606 13.7293 12.2512 13.7293 12.45C13.7293 12.6488 13.6505 12.8394 13.51 12.98L12.98 13.51C12.8394 13.6505 12.6488 13.7293 12.45 13.7293C12.2513 13.7293 12.0606 13.6505 11.92 13.51L10 11.59L8.08 13.51C7.93938 13.6505 7.74875 13.7293 7.55 13.7293C7.35125 13.7293 7.16063 13.6505 7.02 13.51L6.49 13C6.34955 12.8594 6.27066 12.6688 6.27066 12.47C6.27066 12.2713 6.34955 12.0806 6.49 11.94L8.41 10L6.49 8.08C6.41742 8.01004 6.35968 7.92616 6.32024 7.83338C6.28081 7.7406 6.26048 7.64082 6.26048 7.54C6.26048 7.43919 6.28081 7.33941 6.32024 7.24662C6.35968 7.15384 6.41742 7.06996 6.49 7L7 6.49C7.14063 6.34955 7.33125 6.27066 7.53 6.27066C7.72875 6.27066 7.91938 6.34955 8.06 6.49L10 8.41L11.92 6.49C12.0606 6.34955 12.2513 6.27066 12.45 6.27066C12.6488 6.27066 12.8394 6.34955 12.98 6.49L13.51 7.02C13.6505 7.16063 13.7293 7.35125 13.7293 7.55C13.7293 7.74875 13.6505 7.93938 13.51 8.08L11.59 10L13.51 11.92Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default CloseSmallIcon;
